import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CommonService } from '../../../services/common';
import { VaultService } from '../../services/vault.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-vault-receive',
  templateUrl: './vault-receive.component.html',
  styleUrl: './vault-receive.component.scss'
})
export class VaultReceiveComponent implements OnInit, OnChanges, OnDestroy {

  vaultReceiveList: any[] = [];
  selectedExportData: any[] = [];
  vaultSupportData: any
  showaddUpdateModal: boolean = false;
  isChildCalled: boolean = false;
  context: string = ''

  private destroy$ = new Subject<void>();

  constructor(public commonService: CommonService, private vaultService: VaultService) { }

  ngOnInit(): void {
    this.refreshEntites();
    this.getVaultReceiveList();
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  refreshEntites() {
  }

  getVaultReceiveList() {
    this.vaultService.filterVaultReceiveList().subscribe(res => {
      if (res?.result?.length > 0) {
        this.vaultReceiveList = res.result.map((item: any) => {
          return {
            ...item,
            Sender: item?.accountDetails?.firstName + ' ' + item?.accountDetails?.lastName,
          };
        });
      }
    });
  }

  changeAddUpdateModelState(event: any) {
    this.context = event.context;
    this.showaddUpdateModal = event.showaddUpdateModal;
  }

  closePaymentDialogue() {
    this.showaddUpdateModal = false;
    this.isChildCalled = false;
  }

  ngOnDestroy(): void {
    // Signal completion to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
